import { Injectable } from '@angular/core';
import { ABOSFunction } from '../model/ABOSFunction';
import { ABOSLink } from '../model/ABOSLink';
import { PERMISSION } from '@clearing-hub/common';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  public static coreFunctions = [
    new ABOSFunction('accounts', 'Accounts', 'fa-users', false, PERMISSION.CH_ACCOUNTS_PAGE_READ),
    new ABOSFunction('cash-movements', 'Cash Movements', 'fa-money', false, PERMISSION.CH_CASH_MOVEMENTS),
    new ABOSFunction('diff-tool', 'Diff tool', 'fa-money-bill-trend-up', false, PERMISSION.CH_DIFF_TOOL),
    new ABOSFunction('downloads', 'Downloads', 'fa-download', false, PERMISSION.CH_DOWNLOADS),
    new ABOSFunction('golden-records', 'Golden records', 'fa-money-bill-trend-up', false, PERMISSION.CH_GOLDEN_RECORDS),
    new ABOSFunction('haircut', 'Haircut', 'fa-money-bill-trend-up', false, PERMISSION.CH_HAIRCUT),
    new ABOSFunction('ynb-limit-stream', 'Limit stream', 'fa-money-bill-trend-up', false, PERMISSION.CH_YNB_LIMIT_STREAM),
    new ABOSFunction('stp', 'STP Trade', 'fa-coins', false, PERMISSION.CH_STP_TRADE),
    new ABOSFunction('swaptrade-poster', 'Swap Trade Poster', 'fa-medkit', false, PERMISSION.CH_SWAP_RATE_POSTER)
  ];

  public static otherFunctions = [
    new ABOSFunction('cash-movement-reconciliation', 'Cash movement reconciliation', 'fa-money', false, PERMISSION.CH_FIND_RECONCILIATION),
    new ABOSFunction('commission', 'Commission', 'fa-dollar', false, PERMISSION.CH_COMMISSION_STATISTIC),
    new ABOSFunction('crypto-address', 'Crypto address', 'fa-database', false, PERMISSION.CH_CRYPTO_ADDRESS_READ),
    new ABOSFunction('huobi', 'Exchange Deposit History', 'fa-exchange', false, PERMISSION.CH_HUOBI_DEPOSIT_WITHDRAW),
    new ABOSFunction('posting-methods', 'Posting Methods', 'fa-list-ul', false, PERMISSION.CH_POSTING_METHODS),
    new ABOSFunction('rates', 'Rates', 'fa-file-text-o', false, PERMISSION.CH_RATES_PAGE),
    new ABOSFunction('redis-limits', 'Redis limits', 'fa-money-bill-trend-up', false, PERMISSION.CH_REDIS_INTERFACE),
    new ABOSFunction('risk-dashboard', 'Risk Dashboard', 'fa-exchange', false, PERMISSION.CH_LIMIT_MANAGER),
    new ABOSFunction('statistic-dashboard', 'Statistic dashboard', 'fa-money-bill-trend-up', false, PERMISSION.CH_STATISTICS_DASHBOARD)
  ];

  public static links = [
    new ABOSLink('https://hub.clearing.cc/repolend', 'Lending Market', 'fa-external-link', false, PERMISSION.CH_REPO_LEND),
    new ABOSLink('https://hub.clearing.cc/new', 'Crypto clearing web gui', 'fa-external-link', false, PERMISSION.CH_CRYPTO_CLEARING_WEB_GUI)
  ];
}
